/**
 * Created by zhangxiaoqing on 2017/5/16.
 */
import ajax from './ajax'
import {config, errorCode, errorCodeByType, constans} from './config.js'
import store from '../store/index.js'
export default function api (url, urlData, data, method = 'GET', baseUrl, authPermission, authority,isGwforward) {
  let tenantId = store.state.webset.tenantId && store.state.webset.tenantId;
  //tenantId = 123889
  let gateway = process.env.GATEWAY//新的网关不走转发
  let TOKEN = store.state.TOKEN && store.state.TOKEN;//增加token解决设计器登录后台登录两次问题
  let isTenant = process.env.NODE_ENV=='development' ? true: false//本地环境新网关也传tenantId
  if(!gateway || (gateway && isTenant)) urlData.tenantId = tenantId;
  
  let keyddd = url.indexOf('?') == -1 ? '?' : '&'
  if (url.indexOf('_d=') == -1 ) {
    url = url + keyddd +"_d=" + (new Date().getTime());
  }else {
    url = changeURLArg(url,'_d',new Date().getTime())
  }
  //替换参数的值
  function changeURLArg(url,arg,arg_val){ 
    var pattern=arg+'=([^&]*)'; 
    var replaceText=arg+'='+arg_val; 
    if(url.match(pattern)){ 
        var tmp='/('+ arg+'=)([^&]*)/gi'; 
        tmp=url.replace(eval(tmp),replaceText); 
        return tmp; 
    }else{ 
        if(url.match('[\?]')){ 
            return url+'&'+replaceText; 
        }else{ 
            return url+'?'+replaceText; 
        } 
    } 
    return url+'\n'+arg+'\n'+arg_val; 
  }

  switch (method) {
    case 'FILE':
    for (var key in urlData) {
        url.indexOf('?') > 0 ? url += `&${key}=${urlData[key]}` : url += `?${key}=${urlData[key]}`
      }
      if(authority){
        url = gateway ? newGateWayParam(url,baseUrl,data,authPermission,urlData,TOKEN,gateway) : forwardParam(url,baseUrl,tenantId,data,authPermission,urlData,TOKEN,isGwforward)
        baseUrl = ''
      }
      return ajax.file(url, data, baseUrl)
    case 'GET':
    if(!gateway || (gateway && isTenant)) data.tenantId = tenantId
      for (let key in data) {
        url.indexOf('?') > 0 ? url += '&' + key + '=' + data[key] : url += '?' + key + '=' + data[key]
      }
      if(authority){
        url = gateway ? newGateWayParam(url,baseUrl,data,authPermission,urlData,TOKEN,gateway) : forwardParam(url,baseUrl,tenantId,data,authPermission,urlData,TOKEN,isGwforward)
        baseUrl = ''
      }
      return ajax.get(url, baseUrl)
    case 'POSTJSON':
      for (var key in urlData) {
        url.indexOf('?') > 0 ? url += `&${key}=${urlData[key]}` : url += `?${key}=${urlData[key]}`
      }
      if(authority){
        url = gateway ? newGateWayParam(url,baseUrl,data,authPermission,urlData,TOKEN,gateway) : forwardParam(url,baseUrl,tenantId,data,authPermission,urlData,TOKEN,isGwforward)
        baseUrl = ''
      }
      return ajax.postJson(url, data, baseUrl)

    case 'POST':
      for (var key in urlData) {
        url.indexOf('?') > 0 ? url += `&${key}=${urlData[key]}` : url += `?${key}=${urlData[key]}`
      }
      if(authority){
        url = gateway ? newGateWayParam(url,baseUrl,data,authPermission,urlData,TOKEN,gateway) : forwardParam(url,baseUrl,tenantId,data,authPermission,urlData,TOKEN,isGwforward)
        baseUrl = ''
      }
			return ajax.post(url, data, baseUrl)

    case 'UPLOADFILE':
		  for (var key in urlData) {
				url.indexOf('?') > 0 ? url += `&${key}=${urlData[key]}` : url += `?${key}=${urlData[key]}`
			}
			if(authority){
				url = gateway ? newGateWayParam(url,baseUrl,data,authPermission,urlData,TOKEN,gateway) : forwardParam(url,baseUrl,tenantId,data,authPermission,urlData,TOKEN,isGwforward)
				baseUrl = ''
			}
			return ajax.uploadFile(url, data, baseUrl)

    case 'SENDMAIL':
			for (var key in urlData) {
        url.indexOf('?') > 0 ? url += `&${key}=${urlData[key]}` : url += `?${key}=${urlData[key]}`
      }
      if(authority){
        url = gateway ? newGateWayParam(url,baseUrl,data,authPermission,urlData,TOKEN,gateway) : forwardParam(url,baseUrl,tenantId,data,authPermission,urlData,TOKEN,isGwforward)
        baseUrl = ''
      }
      return ajax.sendMail(url, data, baseUrl)

    case 'FILESTREAM':
			for (var key in urlData) {
        url.indexOf('?') > 0 ? url += `&${key}=${urlData[key]}` : url += `?${key}=${urlData[key]}`
      }
      if(authority){
        url = gateway ? newGateWayParam(url,baseUrl,data,authPermission,urlData,TOKEN,gateway) : forwardParam(url,baseUrl,tenantId,data,authPermission,urlData,TOKEN,isGwforward)
        baseUrl = ''
      }
      return ajax.fileStream(url, data, baseUrl)
  }
}
// export default function api (url, data, method = 'GET', baseUrl) {
//   switch (method) {
//     case 'POST':
//       data = forwardParam(url, data, 'post', baseUrl)
//       return ajax.post('', data)
//     case 'GET':
//       data = forwardParam(url, data, 'get', baseUrl)
//       return ajax.post('', data)
//       // for (let key in data) {
//       //   url.indexOf('?') > 0 ? url += '&' + key + '=' + data[key] : url += '?' + key + '=' + data[key]
//       // }
//     case 'GETREST':
//       data = forwardParam(url, data, 'get', baseUrl)
//       return ajax.post('', data)
//     case 'POSTJSON':
//       data = forwardParam(url, data, 'post', baseUrl)
//       return ajax.post('', data)
//     case 'DELETE':
//       data = forwardParam(url, data, 'delete', baseUrl)
//       return ajax.post('', data)
//     case 'PUT':
//       data = forwardParam(url, data, 'put', baseUrl)
//       return ajax.post('', data)
//   }
// }

let forwardParam = (url, baseUrl, tenantId,data, authPermission,urlData,TOKEN,isGwforward)=>{
  baseUrl = baseUrl == undefined ? process.env.ORIGINAL_ROOT : baseUrl;
  baseUrl += url
  let idx = authPermission && authPermission.length && authPermission.indexOf(':');
  if(idx >= 0){
    let key = authPermission.substring(0,idx)
    authPermission = data[key] ? authPermission.replace(key, data[key]) : authPermission.replace(key, urlData[key]);
    // authPermission = authPermission.slice(idx+1, authPermission.length)
  }
  if(idx == undefined){
    authPermission = undefined
  }
  let forward = '';
  let paramUrl = '';

  if(isGwforward){//如果是saasapi 开头的 isGwforward为true的话 走gwforward 转发
    forward = config.gwforward
    paramUrl = `${forward.url}${baseUrl}&tenantId=${tenantId}${authPermission? '&authPermission=' + authPermission:''}${TOKEN? '&TOKEN=' + TOKEN:''}`
  }else{
    forward = config.originalForward
    paramUrl = `${forward.url}?url=${encodeURIComponent(baseUrl)}&tenantId=${tenantId}${authPermission? '&authPermission=' + authPermission:''}${TOKEN? '&TOKEN=' + TOKEN:''}`
  }
  return paramUrl
}
let newGateWayParam = (url, baseUrl,data, authPermission,urlData,TOKEN,gateway)=>{

  baseUrl = baseUrl == undefined ? process.env.ORIGINAL_ROOT : baseUrl;
  baseUrl += url
  let idx = authPermission && authPermission.length && authPermission.indexOf(':');
  if(idx >= 0){
    let key = authPermission.substring(0,idx)
    authPermission = data[key] ? authPermission.replace(key, data[key]) : authPermission.replace(key, urlData[key]);
    // authPermission = authPermission.slice(idx+1, authPermission.length)
  }
  if(idx == undefined){
    authPermission = undefined
  }
  let forward = {url: gateway}
  // if(url.indexOf('/place/v2/search') >= 0) {
  //   forward = config.baiduMapForward;
  //   baseUrl = url
  // }
  let perMark = baseUrl.indexOf('?') > 0 ? '&' : '?'
  let TokenMark = baseUrl.indexOf('?') > 0 || authPermission ? '&' : '?'
  let paramUrl = `${forward.url}${baseUrl}${authPermission? `${perMark}authPermission=${authPermission}`:''}${TOKEN? `${TokenMark}TOKEN=${TOKEN}`:''}`
  return paramUrl
}
export {forwardParam}



// WEBPACK FOOTER //
// ./src/api/api.js